/* flatoo CVR interaction diagnostics -- custom GTM events only.
   Deliberately does NOT publish GA4 purchase/add_to_cart/checkout standard events.
   No addresses, selected prefecture, customer identifiers, or form data are sent. */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;
  var rules = [
    ['.fcvr-ranking__card', 'flatoo_cvr_ranking_click', 'sales_ranking'],
    ['.fcvr-shelf__item', 'flatoo_cvr_shelf_click', 'category_shelf'],
    ['.fcvr-life__card', 'flatoo_cvr_lifestyle_click', 'lifestyle'],
    ['.fcvr-feature-products__product', 'flatoo_cvr_feature_product_click', 'feature_product'],
    ['.fcvr-feature-products__primary', 'flatoo_cvr_feature_collection_click', 'feature_collection'],
    ['.fcvr-collection-guide a', 'flatoo_cvr_guide_click', 'collection_guide'],
    ['.flatoo-cvr-facts__size-link', 'flatoo_cvr_size_link_click', 'product_size'],
    ['.fcvr-buy__item a[href="/pages/layout"]', 'flatoo_cvr_simulator_click', 'buying_guide'],
    ['.fcvr-feature-products__secondary', 'flatoo_cvr_simulator_click', 'feature']
  ];
  function productHandle(href) {
    if (!href) return '';
    try {
      var url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return '';
      var match = url.pathname.match(/^\/products\/([a-z0-9_-]+)(?:\/|$)/i);
      return match ? match[1] : '';
    } catch (ignore) { return ''; }
  }
  function emit(name, component, handle, rank) {
    var payload = { event: name, flatoo_component: component, flatoo_theme_variant: 'cvr_20261101' };
    if (handle) payload.flatoo_product_handle = handle;
    if (rank && Number.isInteger(rank) && rank > 0 && rank <= 12) payload.flatoo_rank = rank;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }
  document.addEventListener('click', function (e) {
    var source = e.target;
    if (!source || !source.closest) return;
    var corporateLink = source.closest('a[data-flatoo-b2b-source]');
    if (corporateLink) {
      // Track only the placement, not form fields or personal data.
      var placement = corporateLink.getAttribute('data-flatoo-b2b-source') || 'other';
      if (/^(home|home-mobile|product|product-mobile|footer)$/.test(placement)) {
        emit('flatoo_cvr_b2b_entry_click', 'corporate_'+placement, '', 0);
      }
      return;
    }
    for (var i = 0; i < rules.length; i++) {
      var a = source.closest(rules[i][0]);
      if (!a) continue;
      var rankElement = a.querySelector('.fcvr-ranking__rank');
      var rank = rankElement ? Number(rankElement.textContent.trim()) : 0;
      emit(rules[i][1], rules[i][2], productHandle(a.getAttribute('href')), rank);
      break;
    }
  }, false);
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el && el.matches && el.matches('[data-arrival-prefecture]')) {
      // Count deliberate shipping-info use; NEVER send the selected prefecture.
      emit('flatoo_cvr_delivery_selection', 'delivery_estimate', '', 0);
    }
  }, false);
})();
